/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyContestEvaluationSummary = {

	get (context, agencyContestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-evaluation-summary"
			+ "?agencyContestId=" + agencyContestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTeam (context, teamId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-contest-evaluation-summary/team"
			+ "?teamId=" + teamId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, projectEvaluationSummaryDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-contest-evaluation-summary"
			, projectEvaluationSummaryDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
